/** @jsxRuntime classic */ // <-- remove this when TS updated to 4.1
/** @jsx jsx */ // <-- remove this when TS updated to 4.1
import { jsx } from '@emotion/core';
import { FC, useContext } from 'react';
import { useMutation } from 'react-query';
import { Button } from '../..';
import { Vodafone } from '../../../assets';
import { appStore } from '../../../state';
import { Copy } from '../../../types';
import { generateSignedRequestConfig } from '../../../utils';
import { baseURL, postVfPayment } from '../../../api';
import VFfont from '../../../assets/fonts/VodafoneRg-Regular.ttf';

interface VodafonePayProps extends Copy {
  /**
   * The css class for the input. Handled internally by emotion
   */
  className?: string;
}

const VodafonePay: FC<VodafonePayProps> = ({ fallbackCopy, localeCopy }) => {
  const { dispatch, state } = useContext(appStore);
  const { form, user } = state;
  const { apiKey, apiSecret, countryCode, id } = user;
  const {
    isLoading: postVfDataIsLoading,
    mutateAsync: postVfPaymentData,
  } = useMutation(postVfPayment, {
    onError: async (error: any) => {
      const { message } = await error;
      console.error('Error posting VF payment: ', await error);
      if (message === 'User has active renewal subscription!') {
        dispatch({
          type: 'ADD_MESSAGE',
          payload: {
            dismissable: true,
            id: new Date().getTime(),
            text:
              localeCopy?.errors?.HAS_ACTIVE_RENEWAL ||
              fallbackCopy.errors.HAS_ACTIVE_RENEWAL,
            timeout: 7,
            type: 'error',
          },
        });
        return;
      }

      dispatch({
        type: 'ADD_MESSAGE',
        payload: {
          dismissable: true,
          id: new Date().getTime(),
          text:
            localeCopy?.errors?.PAYMENT_ERROR ||
            fallbackCopy.errors.PAYMENT_ERROR,
          timeout: 7,
          type: 'error',
        },
      });
    },
    onSuccess: (data: any) => {
      window.open(data.paymentPageUrl, '_self');
    },
  });

  const handleClick = async () => {
    /**
     * there is a sily bug with axios-hooks that cancels requests when declaring
     * config in the hook and in this manual request callback function so having
     * to define config here. May swap out axios-hooks
     */
    await postVfPaymentData({
      config: generateSignedRequestConfig({
        apiKey,
        apiSecret,
        countryCode,
        data: {
          origin: document.location.origin,
          productId: form.selectedPlan?.productId,
        },
        id,
        method: 'POST',
        url: `${baseURL}/api/billing/vodafone/user/${id}/paymentdata`,
      }),
    });
  };

  return (
    <Button
      css={{
        '@font-face': {
          fontFamily: 'Vodafone Rg',
          src: `url(${VFfont}) format('truetype')`,
          fontStyle: 'normal',
          fontWeight: 'normal',
        },
        backgroundColor: '#e60000',
        borderWidth: 0,
        borderRadius: 6,
        fontFamily: 'Vodafone Rg',
        fontSize: 18,
        fontWeight: 500,
        height: 40,
        lineHeight: '24px',
        minWidth: 80,
        width: '100%',
        '&:active': {
          backgroundColor: ' #990000',
        },
        '&:hover': {
          backgroundColor: '#990000',
        },
        svg: {
          marginRight: 8,
        },
      }}
      isBusy={postVfDataIsLoading}
      isBusyText={
        localeCopy?.components?.button?.loading ||
        fallbackCopy?.components.button.loading
      }
      onClick={handleClick}>
      <Vodafone fill='#FFF' />
      Pay
    </Button>
  );
};

export default VodafonePay;
